import React from 'react';

const AdminUserContext = React.createContext({
  adminUser: null,
  setAdminUser: () => {}
});

export default AdminUserContext;
